import { fetchLoginInfo, getGlobalVariables } from '../apis';
import { LoginInfo } from '../interfaces';
import { initHowxmConfig } from './howxm';
import { isEmpty } from '@libs/shared';
import { handleHeartbeatVisibilityChange, setHeartbeatTimer } from './heartbeat';
import { authModel, globalState, GlobalState } from '../models';

export interface GlobalOptions extends Partial<Pick<GlobalState, 'origin' | 'heartbeatCallback'>> {
    /** 是否开启浩客，默认 false */
    enableHowxm?: boolean;
    /** 子产品传入的浩客 appId，优先级高于 public_configuration 返回的 howxm_project_id */
    howxmProjectId?: string;
    /** 是否为套件管理员，支持异步获取 */
    isSuiteManager?: boolean | Promise<boolean>;
    /** 是否开启 fetch loginInfo 轮询，与云平台后端保持心跳，默认 false */
    keepHeartbeat?: boolean;
    loginInfo?: LoginInfo;
}

/**
 * 初始化当前登录账号信息
 */
export const configGlobalAuth = (options?: GlobalOptions) => {
    return initGlobalAuth(options).then(() => authModel);
};

export const initGlobalAuth = (options?: GlobalOptions) => {
    const {
        loginInfo,
        origin = globalState.origin,
        enableHowxm = false,
        howxmProjectId,
        isSuiteManager = false,
        keepHeartbeat = false,
        heartbeatCallback
    } = options || {};

    globalState.origin = origin;

    const initLoginInfo = () => {
        return new Promise<LoginInfo>((resolve, reject) => {
            if (loginInfo) {
                authModel.initConfig(loginInfo);
                resolve(loginInfo);
            } else {
                initGlobalVariables().then(() => {
                    fetchLoginInfo(globalState.suiteId)
                        .then((res) => {
                            authModel.initConfig(res);
                            resolve(res);
                        })
                        .catch((error) => {
                            reject(error);
                        });
                });
            }
        });
    };

    return initLoginInfo()
        .then((res) => {
            if (enableHowxm) {
                Promise.resolve(isSuiteManager)
                    .catch(() => false)
                    .then((isSuiteManager) => initHowxmConfig(isSuiteManager, howxmProjectId));
            }
            if (keepHeartbeat) {
                globalState.heartbeatCallback = heartbeatCallback;
                setHeartbeatTimer();
                window.addEventListener('visibilitychange', handleHeartbeatVisibilityChange);
            }
            return res;
        })
        .catch((error) => {
            throw error;
        });
};

export const getLoginInfo = () => authModel;

export const initGlobalVariables = () => {
    if (!isEmpty(globalState.options)) {
        return Promise.resolve();
    }
    return getGlobalVariables().then((res) => {
        const {
            version,
            qixin_search_service,
            tenant_register,
            corp_coop,
            member_auto_sync,
            contact_phone,
            coin,
            platform_sms,
            register_persona,
            is_mobile,
            ...otherOptions
        } = res.data;

        globalState.version = version;
        globalState.isMobile = is_mobile;
        globalState.options = {
            ...otherOptions,
            function_map: {
                qixin_search_service,
                corp_coop,
                member_auto_sync,
                contact_phone,
                coin,
                platform_sms,
                tenant_register,
                register_persona
            }
        };
    });
};
